export default __webpack_public_path__ + "atomic/_patterns/01-atoms/bg-overlay/_bg-overlay.twig";